<div id="generalContentProductView" *ngIf="!diviceXs && !diviceSm">

    <div id="contentProductView" fxLayout="row" fxLayoutAlign="space-around center">

        <ngx-gallery [options]="galleryOptions" [images]="galleryImages" class="ngx-gallery" fxFlex="40"></ngx-gallery>


        <div id="infoProduct" class="content" fxFlex="50">

            <p class="reference">Código del producto: {{product.reference}}</p>

            <h4 class="brand">{{product.brand}}</h4>
            <h2>{{product.name}}</h2>

            <h3>$ {{product.price | currency:'COP '}}</h3>

            <h4 class="gessiPoints">{{product.points | number}} <span>Gessis</span><span id="btn-actInfoGessiPoints" class="material-icons" (mouseover)="infoGessiPoints=true" (mouseout)="infoGessiPoints=false">help_outline</span></h4>

            <div id="infoGessiPoints" [hidden]="!infoGessiPoints">
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
            </div>

            <div class="addToCar" fxLayout="row" fxLayoutAlign="start center">
                <mat-form-field>
                    <mat-label>Cantidad</mat-label>
                    <input matInput type="number" [(ngModel)]='productQuantity' min="1">
                    <!-- <input matInput type="number" min="1"> -->
                </mat-form-field>

                <button id="btn-addToCar" (click)="addToCar(product)">Añadir al Carrito</button>
            </div>

            <p class="pointsToAccumulate">Acumula {{product.pointsRevenue}} Gessis</p>

            <button id="btn-characteristics" mat-raised-button (click)="openBottomSheet(product.longDescription)">Características</button>


            <h3 class="availability">Disponibilidad</h3>

            <div class="shipping" fxLayout="row" fxLayoutAlign="start center">
                <figure id="ic-envio"></figure>
                <p>Envía a domicilio</p>
            </div>

        </div>
    </div>

    <hr/>

    <div id="recommended">

        <h2>Recomendados</h2>

        <div id="contentSuggested" fxLayout="row" fxLayoutAlign="start center">
            <mat-card class="cardProductSuggested" *ngFor="let relatedProduct of product.suggestedProducts">

                <div id="img-suggestedProduct" (click)="goToRelatedProduct(relatedProduct.id)">

                    <img mat-card-image src={{relatedProduct.mainPhoto}}>
                </div>

                <mat-card-content (click)="goToRelatedProduct(relatedProduct.id)">
                    <div id="priceRecom">
                        <h3>{{relatedProduct.price | currency:'COP '}}</h3>
                        <h4>{{relatedProduct.points}} <span>Gessis</span></h4>
                    </div>
                    <h2>{{relatedProduct.name}}</h2>
                </mat-card-content>

            </mat-card>


        </div>

        <!-- <div id="contentSuggested">
            <mat-card class="cardProductSuggested" *ngFor="let productSuggested of product.suggestedProducts">

                <div id="img-suggestedProduct" (click)="goToRelatedPRoduct(productSuggested.id)">
                    <img *ngIf="productSuggested.photos.length > 0" mat-card-image
                        src="{{productSuggested.photos | urlImage}}">
                    <img *ngIf="productSuggested.photos.length === 0" mat-card-image
                        src="../../../../assets/img/caja.jpg ">
                </div>

                <mat-card-content (click)="goToRelatedPRoduct(productSuggested.id)">
                    <div id="priceRecom">
                        <h3>$ {{productSuggested.price | currency:'COP '}}</h3>
                        <h4>{{productSuggested.points | number}} <span>Gessis</span></h4>
                    </div>
                    <h2>{{productSuggested.name}}</h2>
                </mat-card-content>

            </mat-card>
        </div> -->

    </div>

</div>

<div id="generalContentProductView" class="generalContentProductViewCell" *ngIf="diviceXs || diviceSm">

    <div id="contentProductView" fxLayout="column" fxLayoutAlign="center">

        <p class="reference">Código del producto: {{product.reference}}</p>
        <h4 class="brand">{{product.brand}}</h4>
        <h2>{{product.name}}</h2>

        <ngx-gallery [options]="galleryOptions" [images]="galleryImages" class="ngx-gallery"></ngx-gallery>

        <div id="textMain" class="content">

            <div id="costs" fxLayout="row" fxLayoutAlign="space-between center">
                <h3>$ {{product.price | currency:'COP '}}</h3>

                <h4 class="gessiPoints" fxLayout="row" fxLayoutAlign="space-between center">
                    {{product.points | number}}
                    <span>Gessis</span>
                    <span id="btn-actInfoGessiPoints" class="material-icons" (mouseover)="infoGessiPoints=true" (mouseout)="infoGessiPoints=false">help_outline</span>
                </h4>

                <div id="infoGessiPoints" [hidden]="!infoGessiPoints">
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                </div>
            </div>


            <p class="pointsToAccumulate">Acumula {{product.pointsRevenue}} Gessis</p>

            <div class="addToCar" fxLayout="row" fxLayoutAlign="start center">
                <mat-form-field>
                    <mat-label>Cantidad</mat-label>
                    <!-- <input matInput type="number" [(ngModel)]='cantidadProducts'> -->
                    <input matInput type="number" [(ngModel)]='productQuantity' min="1">
                    <!-- <input matInput type="number" min="1"> -->
                </mat-form-field>

                <button id="btn-addToCar" (click)="addToCar(product)">Añadir al Carrito</button>
            </div>

            <div id="others">
                <h3>Características</h3>
                <p [innerHTML]="product.description">ng</p>

                <h3 class="availability">Disponibilidad</h3>

                <div class="shipping" fxLayout="row" fxLayoutAlign="start center">
                    <figure id="ic-envio"></figure>
                    <p>Envía a domicilio</p>
                </div>
            </div>

        </div>
    </div>

    <hr/>

    <div id="recommended">

        <h2>Recomendados</h2>

        <div id="contentSuggested" fxLayout="column" fxLayoutAlign="center">
            
            <mat-card class="cardProductSuggested">

                <div id="img-suggestedProduct" (click)="goToRelatedProduct()">

                    <img mat-card-image src="../../../../assets/img/caja.jpg ">
                </div>

                <mat-card-content (click)="goToRelatedProduct()">
                    <div id="priceRecom">
                        <h3>$ 30.000</h3>
                        <h4>3000 <span>Gessis</span></h4>
                    </div>
                    <h2>Caja x30 tapabocas</h2>
                </mat-card-content>

            </mat-card>

            <mat-card class="cardProductSuggested">

                <div id="img-suggestedProduct" (click)="goToRelatedProduct()">

                    <img mat-card-image src="../../../../assets/img/caja.jpg ">
                </div>

                <mat-card-content (click)="goToRelatedProduct()">
                    <div id="priceRecom">
                        <h3>$ 30.000</h3>
                        <h4>3000 <span>Gessis</span></h4>
                    </div>
                    <h2>Caja x30 tapabocas</h2>
                </mat-card-content>

            </mat-card>
        </div>


    </div>
</div>